import { render } from "./Header.vue?vue&type=template&id=c65dd6aa&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=c65dd6aa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\McCoy\\Desktop\\Coding\\Work\\caby_landing_page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c65dd6aa"]])

export default __exports__